import {IBackDropWizardState} from "../../../types/ui/wizard/back-drop";
import {BackDropEditingMode} from "../../../types/types";
import {defaultEnvironment} from "../../../../peregrine/processor";

export const initialBackDropState: IBackDropWizardState = {
  mode: BackDropEditingMode.CreateNew,
  envMap: defaultEnvironment,
  orgEnvMap: defaultEnvironment
};
